<div class="wrapper">
  <div class="trackTitleContainer">
    @if ((currentAudio$ | async) != null) {
      <tun-scrollable-text class="trackTitle" [text]="(currentAudio$ | async).title"></tun-scrollable-text>
    }
  </div>
  <div class="trackGroupContainer">
    @if ((currentAudio$ | async) != null) {
      <tun-scrollable-text class="trackGroup" [text]="(currentAudio$ | async).group"></tun-scrollable-text>
    }
  </div>
</div>
